import axios from 'axios';
import config from '../config';

export const getStudentProfileUrl = (studentid) => {
    return `${config.STUDENT_PROFILE_URL}?studentid=${studentid}`;
};

export const updateStudentNotes = (staffid, studentid, notes) => {
    return axios.get(
        `${config.BASE_URL}${config.UPDATE_STUDENT_NOTES}?staffid=${staffid}&studentid=${studentid}&notes=${notes}`,
    );
};
